var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({directives:[{name:"i18n",rawName:"v-i18n",value:(_vm.options.i18n),expression:"options.i18n"}],ref:"field",staticClass:"btn btn-primary",attrs:{"type":"submit"}},'button',_vm.options.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }